import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { activitiesTradesTableChange } from './actions'

function mapStateToProps(state, hocProps) {
    const id = hocProps?.entId

    return {
        isLoading: state.getIn(
            ['ui', 'workspace', 'report', id, 'blocks', 'activities', 'customData', 'isLoading'],
            []
        ),
        loaded: state.getIn(['ui', 'workspace', 'report', id, 'blocks', 'activities', 'customData', 'loaded'], []),
        data: state.getIn(['ui', 'workspace', 'report', id, 'blocks', 'activities', 'customData', 'data'], []),
        pagination: state.getIn(
            ['ui', 'workspace', 'report', id, 'blocks', 'activities', 'customData', 'pagination'],
            {}
        ),
        sorted: state.getIn(['ui', 'workspace', 'report', id, 'blocks', 'activities', 'customData', 'sorted'], []),
        filter: state.getIn(['ui', 'workspace', 'report', id, 'blocks', 'activities', 'customData', 'filter'], {}),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            activitiesTradesTableChange,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
